import { Theme } from "@mui/material";

type Primary = {
  dark?: string;
  light?: string;
  main?: string;
};

type Text = {
  primary?: string;
  secondary?: string;
};

type ThemOverride = {
  primary?: Primary;
  background?: string;
  paper?: string;
  text?: Text;
};

declare global {
  interface Window {
    theme?: {
      default: string;
      light?: ThemOverride;
      dark?: ThemOverride;
    };
    cl_shadowRootElement: HTMLDivElement;
  }
}

export function overrideTheme(theme: Theme) {
  const variant = theme.palette.mode;
  const variantOverride = window?.theme?.[variant] as ThemOverride;
  if (variantOverride?.background) {
    theme.palette.background.default = variantOverride.background;
  }
  if (variantOverride?.paper) {
    theme.palette.background.paper = variantOverride.paper;
  }
  if (variantOverride?.primary?.main) {
    theme.palette.primary.main = variantOverride.primary.main;
  }
  if (variantOverride?.primary?.dark) {
    theme.palette.primary.dark = variantOverride.primary.dark;
  }
  if (variantOverride?.primary?.light) {
    theme.palette.primary.light = variantOverride.primary.light;
  }
  if (variantOverride?.text?.primary) {
    theme.palette.text.primary = variantOverride.text.primary;
  }
  if (variantOverride?.text?.secondary) {
    theme.palette.text.secondary = variantOverride.text.secondary;
  }

  return theme;
}
